import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import archivos from '@demre/client-common/src/plugins/archivos';
import router from './router';
import store from './store';
import validator from './utils/validator';
import PublicHome from './pages/PublicHome.vue';
import graphql from './utils/graphql';

window.DATA = {};

Vue.use(archivos);
Vue.use(validator);
Vue.config.productionTip = false;

async function init() {
  const query = {
    query: ` query {
      usuario: getUsuario {
        rol {
          nombre
        }
      }
    }`,
  };
  const { usuario } = await graphql.request(query);
  store.commit('setUsuario', usuario);
}

if (window.location.pathname === '/portal-base-datos') {
  new Vue({
    vuetify,
    router,
    store,
    render: h => h(PublicHome)
  }).$mount('#app');
}
else {
  store
  .dispatch('session/load')
  .then(init)
  .then( async () => {
    new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app');
  })
  .catch( async (err) => {
    const mensaje = err.message;
    const { default: Impedimento } = await import(
      './Impedimento' /* webpackChunkName: 'impedimento' */
    );
    new Vue({
      vuetify,
      store,
      render: (h) => h(Impedimento, { props: { mensaje } }),
    }).$mount('#app');
  });
}
